import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

class TeamReportsSection4Step4 extends PureComponent {
  get left_content() {
    const { rndCosts, promotionCosts } = this.props;

    return (
      <span>
        <u>Financial Impact of Your Decisions</u>
        <br />
        <br />
        Both Product Management and Marketing decisions also impact the
        following line items:
        <br />
        <br />- <b>R&D Costs:</b> Your R&D Costs of{" "}
        <AbbreviatedMillionNumberFormat
          value={rndCosts}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was driven by the quality of the product features and the number of
        products designed by your Head of Product Management.
        <br />
        <br />- <b>Promotion Costs:</b> Your Promotion Costs of{" "}
        <AbbreviatedMillionNumberFormat
          value={promotionCosts}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        was driven by the amount that your Head of Product Marketing spent on
        creating awareness.
        <br />
        <br />
        To learn more about what impacts these Operating Expenses, please review
        the following content:
        <br />
        <TypeformLink title="Marketing Mix" url={TypeformUrls.MARKETING_MIX} />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Market Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection4Step4;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-4/step-4.js